<template>
  <div class="iquote-expired d-flex">
    <span
      v-if="isExpired"
      class="ml-auto text-white text-right font-weight-bold font-size-lg pl-4 pr-4 pr-md-0"
      v-dynamic-content:offer_date_expired
    ></span>
    <span
      v-else
      class="ml-auto text-white text-right font-weight-bold font-size-lg pl-4 pr-4 pr-md-0"
      v-dynamic-content:offer_date="[offerExpiryDate]"
    ></span>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ExpiryDate',
  computed: {
    ...mapGetters(['offerExpiryDate', 'isExpired']),
  },
}
</script>
